<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" :id="id">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">あらすじ編集</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h3 class="mb-3">
                        {{section.section_name}}
                    </h3>
                    <div class="text-pane">
                        <div class="text-pane-dummy">{{outline.synopsis + '\u200b'}}</div>
                        <textarea placeholder="あらすじ（140文字以内）。空欄の場合、本文冒頭140文字が表示されます。" v-model="outline.synopsis" class="text-pane-editor"></textarea>
                    </div>
                    <div class="mb-3 small text-right">
                        <span :class="{'text-danger': invalidSynopsis}">
                            {{ outline.synopsis.length }}
                        </span>
                        / 140
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="btn-group file-selector">
                            <label class="btn btn-secondary" style="margin: 0;" for="eyecatch">
                                <i class="fas fa-file-image"></i>
                                背景画像選択...
                                <input type="file" id="eyecatch" ref="eyecatch" @change="fileSelected()" accept="image/*" class="d-none" />
                            </label>
                            <button type="button" @click="removeImage()" class="btn btn-light">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div v-if="$store.getters.user && curr">
                        <picture-storage :curr="curr" :max="$store.getters.user.storage_limit"></picture-storage>
                    </div>
                    <div class="d-flex justify-content-center my-3" v-if="file.url">
                        <img :src="file.url" class="preview" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()" :disabled="!canSave">保存</button>
                </div>
                <div class="modal-body">
                    <div class="mb-3 small" v-html="$filters.ruby(section.body)"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 1px solid #bbb;
    border-radius: .5rem;
    max-width: 640px;
    margin: 1rem auto;
    .text-pane-dummy {
        overflow: hidden;
        visibility: hidden;
        font-size: 1rem;
        line-height: 1.7rem;
        box-sizing: border-box;
        padding: 1rem 1.5rem;
        min-height: 120px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
    }
    .text-pane-editor {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 1rem;
        line-height: 1.7rem;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        padding: 1rem 1.5rem;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        // opacity: .5;
        &:focus {
                outline: none;
        }
    }
}
.preview {
    width: 232px;
    height: 300px;
    object-fit: cover;
    border-radius: .5rem;
}
</style>

<script>
import PictureStorage from 'components/PictureStorage';
export default {
    components: {
        PictureStorage
    },
    props: {
        id: {
            default: 'outline-editor'
        },
        section_id: {
            default: null,
        },
    },
    data() {
        return {
            section: {},
            outline: {
                synopsis: ""
            },
            file: {
                info: null,
                url: null,
            },
            curr: 0,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/books/outline/edit", {params: {
                id: this.section_id
            }}).then(res => {
                this.section = res.data.section;
                if (this.section.outline) {
                    this.outline = this.section.outline;
                    if (this.section.outline.picture) {
                        this.file.url = this.section.outline.picture.url;
                    }
                } else {
                    this.outline = {
                        section_id: this.section_id,
                        synopsis: ""
                    };
                }
                this.curr = res.data.curr;
            }).catch(err => { alert.err(err.response) });
        },
        save() {
            const fd = new FormData();
            fd.append('info', this.file.info);
            fd.append('url', this.file.url);
            fd.append('synopsis', this.outline.synopsis);
            fd.append('section_id', this.outline.section_id);
            if (this.outline.id) {
                fd.append('id', this.outline.id);
            }
            axios.post("/mypage/books/outline/save", fd).then(res => {
                this.$emit("saved");
                $("#" + this.id).modal("hide");
            }).catch(err => { alert.err(err.response) });
        },
        fileSelected() {
            if (this.$refs.eyecatch.files[0].size > 3000 * 1024) {
                alert.err("ファイルサイズが大きすぎます: " + this.$filters.getByte(this.$refs.eyecatch.files[0].size));
                return;
            }
            this.file.info = this.$refs.eyecatch.files[0];
            this.file.url = URL.createObjectURL(this.file.info);
        },
        removeImage() {
            this.file.info = null;
            this.file.url = "";
        }
    },
    computed: {
        invalidSynopsis() {
            if (this.outline.synopsis.length > 140) {
                return true;
            }
            return false;
        },
        canSave() {
            if (this.invalidSynopsis) {
                return false;
            }
            return true;
        }
    },
    mounted() {
        $("#" + this.id).on("show.bs.modal", (e) => {
            this.load();
        });
        $("#" + this.id).on("hide.bs.modal", (e) => {
            this.file = {
                info: null,
                url: null,
            };
            this.outline = {
                synopsis: ""
            };
            this.section = {
            };
        });
    }
}
</script>